import { get, post } from 'utils/api';

export const getOpenSessions = (params) => get(`/open-sessions`, params);

export const getOpenSessionMeterValues = (transactionId) => get(`/open-sessions/${encodeURIComponent(transactionId)}/metervalues`);

export const closeOpenSession = (transactionId, data) => post(`/open-sessions/${encodeURIComponent(transactionId)}/close`, data);

export const openSessions = {
  getOpenSessions,
  getOpenSessionMeterValues,
  closeOpenSession,
};
